import { call, put, select, all } from 'redux-saga/effects';
import { addItemRequest, getItemsRequest, updateItemRequest } from '../../spItems/api';
import { VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from 'src/api/config';
import { getReportCompletedActionsSuccess, getReportFactory, getReportFactorySuccess } from '../actions';
import { getDefaultSaga } from './getDefaultSaga';
import { updateDefaultSaga } from 'src/modules/spItems/sagas/updateDefaultSaga';
import { addDefaultSaga } from 'src/modules/spItems/sagas/addDefaultSaga';
import { actionsVPO, VPOInconsistences } from 'src/pages/DashboardPage/vpo/api/vpo.config';
import { ContentTypeIdDirectory, ContentTypeIdGroupRequirement, ContentTypeIdRequirement } from '../api/config';
import { myTaskActionsListName } from 'src/api/config/myTasksActions.config';

function* fetchChunkTaskActions(chunk: string[]) {
  return yield call<any>(getDefaultSaga, {
    listName: myTaskActionsListName,
    filters: {
      MImportantHashTagOld: chunk.map(item => '*vpo_' + item)
    },
  });
}

function* fetchAllTaskActions(ids_inconsistencies: string[]) {
  const chunkSize = 20; 

  if (ids_inconsistencies.length <= chunkSize) {
    // Если элементов 100 или меньше, выполняем один запрос
    return yield call(fetchChunkTaskActions, ids_inconsistencies);
  } else {
    // Делим массив на куски
    const chunk = ids_inconsistencies.slice(0, chunkSize);
    const remaining = ids_inconsistencies.slice(chunkSize);

    // Выполняем запрос для текущего куска и рекурсивно для оставшихся
    const [currentResult, remainingResult] = yield all([
      call(fetchChunkTaskActions, chunk),
      call(fetchAllTaskActions, remaining)
    ]);

    console.log(remainingResult);

    // Объединяем результаты
    return [
      ...(Array.isArray(currentResult) ? currentResult : [currentResult.items]),
      ...(Array.isArray(remainingResult) ? remainingResult : [remainingResult.items]),
    ];
  }
}

function* fetchChunkInconsistencies(chunk: string[]) {
  return yield call<any>(getDefaultSaga, {
    listName: 'VPOInconsistencies',
    filters: {
      IdVPOactions: chunk.map(item => item)
    },
  });
}

function* fetchAllInconsistencies(ids_actions: string[]) {
  const chunkSize = 20; 

  if (ids_actions.length <= chunkSize) {
    // Если элементов 100 или меньше, выполняем один запрос
    return yield call(fetchChunkInconsistencies, ids_actions);
  } else {
    // Делим массив на куски
    const chunk = ids_actions.slice(0, chunkSize);
    const remaining = ids_actions.slice(chunkSize);

    // Выполняем запрос для текущего куска и рекурсивно для оставшихся
    const [currentResult, remainingResult] = yield all([
      call(fetchChunkInconsistencies, chunk),
      call(fetchAllInconsistencies, remaining)
    ]);

    // Объединяем результаты
    return [
      ...(Array.isArray(currentResult) ? currentResult : [currentResult.items]),
      ...(Array.isArray(remainingResult) ? remainingResult : [remainingResult.items]),
    ];
  }
}

export function* getReportCompletedActionsSaga({ payload }: any) {
  try {
    if (payload) {

      const { 
        columnReportAction,
        department,
        factoryReport,
        groupReportPeriod,
        year
      } = payload;

      let filters_region: any = {};

      if(columnReportAction.selectedIds.length > 0){
        filters_region.ColumnID = '*' + columnReportAction.selectedIds[0];
      }
      if(groupReportPeriod.selectedIds.length > 0){
        filters_region.GroupTitle = groupReportPeriod.selected.map(title => '*' + title)
      }
      if(factoryReport.selectedIds.length > 0){
        filters_region.FactoryID = factoryReport.selectedIds.map(id => '' + id);
      }
      if(year.selectedIds.length > 0){
        filters_region.Year = '' + year.selected[0]
      }

      let response_region: unknown = yield call<any>(getDefaultSaga, {
        listName: 'ReportRegion',
        filters: filters_region
      })
      
      let response_info_questionary: unknown = null;
      let filters_status: any = {};

      if(columnReportAction.selectedIds.length > 0){
        filters_status.ColumnID = '*' + columnReportAction.selectedIds[0];
      }
      if(groupReportPeriod.selectedIds.length > 0){
        filters_status.GroupTitle = groupReportPeriod.selected.map(title => '*' + title)
      }
      if(factoryReport.selectedIds.length > 0){
        filters_status.FactoryID = factoryReport.selectedIds.map(id => '' + id);
      }
      if(year.selectedIds.length > 0){
        filters_status.Year = '*' + year.selected[0]
      }

      response_info_questionary = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        filters: filters_status
      })
      
      let filters_actions : any = {};

      if(columnReportAction.selectedIds.length > 0){
        filters_actions.ColumnID = '*' + columnReportAction.selectedIds[0];
      }

      if(columnReportAction.selectedIds.length > 0){
        filters_actions.GroupID = groupReportPeriod.selectedIds.map(id => '*' + id);
      }
      
      let response_actions: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOActions',
        filtersType: 'and',
        filters: filters_actions
      });

      let ids_actions: (number|string)[] = [];

      if(
        response_actions &&
        response_actions.items &&
        response_actions.items.length > 0
      ){
        response_actions.items.map((item: any) => {
          ids_actions.push(''+item.ID);
        })
      }

      let response_inconsistencies: any = [],
      response_tasks: any = [];


      console.log('response_inconsistencies', ids_actions);
      if(
        ids_actions &&
        ids_actions.length > 0
      ){
        let result = yield call(fetchAllInconsistencies, ids_actions);
        
        if(
          result &&
          result.items
        ){
          result = [result.items];
        }
          
        if(
          result && 
          result.length > 0
        ){
          result.map((items) => {
            if(
              items &&
              items.length > 0 &&
              response_inconsistencies
            ){
              response_inconsistencies = [
                ...response_inconsistencies,
                ...items
              ]
            }
          })
        }
        // response_inconsistencies = yield call<any>(getDefaultSaga, {
        //   listName: 'VPOInconsistencies',
        //   filters: {
        //     IdVPOactions: ids_actions
        //   },
        // }) 

        console.log('response_inconsistencies', response_inconsistencies);

        let ids_inconsistencies: (string)[] = []

        if(
          response_inconsistencies &&
          response_inconsistencies.length > 0
        ){
          response_inconsistencies.map((item: any) => {
            ids_inconsistencies.push(item.ID);
          })
        }

        console.log('response_tasks', ids_inconsistencies.map(item => '#VPO_' + item));

        if(
          ids_inconsistencies &&
          ids_inconsistencies.length > 0
        ){


          // const ids_inconsistencies = ['id1', 'id2', 'id3', /* ... до 300 элементов */];
          let result = yield call(fetchAllTaskActions, ids_inconsistencies);

          if(
            result && 
            result.items
          ){
            result = [result.items];
          }
          
          if(
            result && 
            result.length > 0
          ){
            result.map((items) => {
              if(
                items &&
                items.length > 0 &&
                response_tasks
              ){
                response_tasks = [
                  ...response_tasks,
                  ...items
                ]
              }
            })
          }

        }

      }

      console.log('response_tasks', response_tasks);

      yield put(
        getReportCompletedActionsSuccess({
          response_info_questionary,
          response_actions,
          response_inconsistencies,
          response_tasks: {
            items: response_tasks
          },
          response_region,
          filters: {
            columnReportAction,
            department,
            factoryReport,
            groupReportPeriod,
            year
          }
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
